module.exports = __webpack_public_path__ + "static/media/IMG_0347.d77f88e8.JPG";